import { useEffect, useState } from 'react';
import { organizationApi } from '@/services/api';

/**
 * Minimal bottom-of-page strip showing the tenant/instance name — for generic
 * pages that don't already carry a classification legend (Home, Audit Log,
 * Comments Log, Settings, Help). Renders nothing until the org name loads.
 */
export function InstanceFooter() {
  const [orgName, setOrgName] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    organizationApi
      .get()
      .then((org) => {
        if (!cancelled) setOrgName(org.name);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!orgName) return null;

  return (
    <div className="px-6 py-1.5 text-xs text-gray-400 flex-shrink-0">
      {orgName}
    </div>
  );
}
